import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuthContext } from './hooks/useAuthContext';
import './index.css';

// Pages & Components
import Navbar from './components/Navbar';
import Create from './pages/Create';
import Home from './pages/Home';
import Login from './pages/Login';
import Settings from './pages/Settings';

function App() {
	const { user } = useAuthContext();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false); // ✅ Always update loading when user state changes
	}, [user]);

	if (loading) return <p>Yükleniyor...</p>;
	return (
		<div className="App">
			<BrowserRouter>
				<Navbar />
				<div className="pages">
					<Routes>
						<Route
							path="/"
							element={user ? <Home /> : <Navigate to="/login" />}
						/>
						<Route
							path="/login"
							element={!user ? <Login /> : <Navigate to="/" />}
						/>
						<Route
							path="/olustur"
							element={user ? <Create /> : <Navigate to="/login" />}
						/>
						<Route
							path="/ayarlar"
							element={user && user.hasSettingsAccess ? <Settings /> : <Navigate to="/" />}
						/>
					</Routes>
				</div>
			</BrowserRouter>
		</div>
	);
}

export default App;
